import { useEffect, useState } from "react";
import { useI18n } from "../lib/i18n";

type InstallPrompt = Event & {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
};

export function InstallApp() {
  const { locale } = useI18n();
  const [prompt, setPrompt] = useState<InstallPrompt | null>(null);
  const [help, setHelp] = useState(false);
  const [installed, setInstalled] = useState(() => window.matchMedia("(display-mode: standalone)").matches);
  useEffect(() => {
    const capture = (event: Event) => { event.preventDefault(); setPrompt(event as InstallPrompt); };
    const done = () => { setInstalled(true); setPrompt(null); };
    window.addEventListener("beforeinstallprompt", capture);
    window.addEventListener("appinstalled", done);
    return () => {
      window.removeEventListener("beforeinstallprompt", capture);
      window.removeEventListener("appinstalled", done);
    };
  }, []);
  if (installed) return null;
  return <div className="install-app">
    <button className="soft-button" type="button" onClick={async () => {
      if (!prompt) { setHelp(value => !value); return; }
      try {
        await prompt.prompt();
        const choice = await prompt.userChoice;
        if (choice.outcome === "accepted") setInstalled(true);
      } catch { setHelp(true); }
      finally { setPrompt(null); }
    }}>{locale === "ur" ? "ایپ انسٹال کریں" : "Install app"}</button>
    {help && <p role="status">{locale === "ur"
      ? "فون پر براؤزر کے شیئر یا مینو سے ہوم اسکرین میں شامل کریں منتخب کریں۔ کمپیوٹر پر براؤزر کے مینو میں انسٹال کا اختیار دیکھیں۔ روزانہ کا منصوبہ اور ریکارڈ محفوظ کرنے کے لیے انٹرنیٹ درکار ہے۔"
      : "On your phone, use the browser's Share or menu button and choose Add to Home Screen. On a computer, look for Install in the browser menu. Daily plans and saving work need an internet connection."}</p>}
  </div>;
}
